module.exports = {"hero":{"title":"Médias","subtitle":"See what we are up too! weather it lunching a new product or volunteering  in the community our media page has it all."},"all-articles":"All articles","articles":"Articles"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr/media-articles.json
// module id = R6HK
// module chunks = 0